import React from "react";
import { ModalProps } from "../Modal/Modal";
import { useRemoteLandProgrammeModalContent } from "./useRemoteLandProgrammeModalContent";
import PortExcursionModal from "./PortExcursionModal";

export interface PortLandProgrammeProps extends ModalProps {
  landProgrammeId: number;
}

const PortLandProgramme: React.FC<PortLandProgrammeProps> = ({
  modal,
  landProgrammeId
}) => {
  const { data, status } = useRemoteLandProgrammeModalContent(landProgrammeId);
  const content = data?.result || {};

  return (
    <PortExcursionModal
      modal={modal}
      status={status}
      hasIcons={false}
      {...content}
    />
  );
};

export default PortLandProgramme;
